import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import GameDemo from './components/GameDemo';
import Features from './components/Features';
import BusinessModel from './components/BusinessModel';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App" dir="rtl">
      <Navbar />
      <Hero />
      <GameDemo />
      <Features />
      <BusinessModel />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
